import type {Block, Inline} from '@contentful/rich-text-types'
import {documentToPlainTextString} from '../../../../lib/utils/analytics'
import type {IndexPage, IndexCard} from '../../../../schemas/contentful/contentTypes/indexTemplate'

type IndexTemplate = IndexPage['fields']['template']

const makeIndexSchema = (page: IndexTemplate, cards: IndexCard[]) => {
  const indexCards = []
  for (const card of cards) {
    const cardFields = card.fields.card?.fields
    const cardHeading =
      cardFields?.heading ?? (cardFields?.headingRich ? documentToPlainTextString(cardFields.headingRich) : undefined)
    if (cardHeading && cardFields?.description) {
      const rawDescription = cardFields.description
      let description = ''

      if (typeof rawDescription === 'string') {
        description = rawDescription
      } else if (rawDescription) {
        description = documentToPlainTextString(rawDescription as unknown as Block | Inline)
      }

      indexCards.push({
        name: cardHeading,
        description,
      })
    }
  }

  const rawHeroDescription = page?.fields?.hero?.fields?.description
  let heroDescription = ''
  if (typeof rawHeroDescription === 'string') {
    heroDescription = rawHeroDescription
  } else if (rawHeroDescription) {
    heroDescription = documentToPlainTextString(rawHeroDescription as unknown as Block | Inline)
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: page?.fields?.hero?.fields?.heading,
    description: heroDescription,
    hasPart: indexCards,
  }
}

const IndexSchema = ({page}: {page: IndexTemplate}) => {
  const cards = page?.fields?.cards ? page.fields.cards.filter(Boolean) : []
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: JSON.stringify(makeIndexSchema(page, cards))}}
    />
  )
}

export {makeIndexSchema}
export default IndexSchema
